// extracted by mini-css-extract-plugin
export default {"empty":"empty-user_empty__nUgKB","captionContainer":"empty-user_captionContainer__xMMCc","caption":"empty-user_caption__Mf08h"};